import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta("页面不存在 - 善良的秘书", "你访问的页面不存在，返回首页继续浏览热门电视剧资源与剧情介绍。");

  return (
    <div className="w-full px-4 md:px-6 py-12 md:py-20">
      <Breadcrumb crumbs={[{ label: "首页", to: "/" }, { label: "页面不存在" }]} />
      <div className="mt-10 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-20 text-center">
        <span className="font-heading text-6xl md:text-8xl font-black text-primary-500">404</span>
        <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-2 max-w-md text-sm text-foreground-600">
          你访问的地址
          <span className="mx-1 rounded bg-background-200 px-1.5 py-0.5 font-label text-xs text-foreground-700">
            {location.pathname}
          </span>
          不存在，可能已经被移除或链接有误。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
          >
            <i className="ri-list-check-2"></i>
            浏览剧集分类
          </Link>
        </div>
      </div>
    </div>
  );
}